module.exports = __webpack_public_path__ + "media/images/custom_page/tempest/exclusive-dd22aafdc24d8e758fb20982ea01eec0.png";